import React from "react";
import { ReactComponent as DeclareDisaster } from "../../../../assets/disaster-icons/declare-disaster.svg";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, canDeclareDisaster }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center ">
      <div className="flex w-[440px] justify-between rounded-t-lg bg-gradient-to-r from-red-700 to-red-600 p-4 ">
        <p className="font-semibold text-white">Add a Disaster</p>
        <div className="cursor-pointer" onClick={onClose}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_9081_292"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_9081_292)">
              <circle
                cx="7"
                cy="7"
                r="7"
                transform="matrix(-1 0 0 1 20 5)"
                fill="white"
              />
              <path
                d="M12 13.4L14.9 16.3C15.0833 16.4833 15.3167 16.575 15.6 16.575C15.8833 16.575 16.1167 16.4833 16.3 16.3C16.4833 16.1167 16.575 15.8833 16.575 15.6C16.575 15.3167 16.4833 15.0833 16.3 14.9L13.4 12L16.3 9.1C16.4833 8.91667 16.575 8.68333 16.575 8.4C16.575 8.11667 16.4833 7.88333 16.3 7.7C16.1167 7.51667 15.8833 7.425 15.6 7.425C15.3167 7.425 15.0833 7.51667 14.9 7.7L12 10.6L9.1 7.7C8.91667 7.51667 8.68333 7.425 8.4 7.425C8.11667 7.425 7.88333 7.51667 7.7 7.7C7.51667 7.88333 7.425 8.11667 7.425 8.4C7.425 8.68333 7.51667 8.91667 7.7 9.1L10.6 12L7.7 14.9C7.51667 15.0833 7.425 15.3167 7.425 15.6C7.425 15.8833 7.51667 16.1167 7.7 16.3C7.88333 16.4833 8.11667 16.575 8.4 16.575C8.68333 16.575 8.91667 16.4833 9.1 16.3L12 13.4ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                fill="#CE2222"
              />
            </g>
          </svg>
        </div>
      </div>
      <div className="w-[440px] rounded-b-lg bg-white p-6 text-center shadow-lg">
        <div
          className="flex items-center justify-center"
          style={{
            width: "80px",
            height: "80px",
            padding: "16px",
            borderRadius: "1000px",
            background: "#FFD182",
            margin: "0 auto",
          }}
        >
          <DeclareDisaster />
        </div>
        {/* Conditionally render the disaster declaration prompt */}
        {canDeclareDisaster && (
          <p className="text-lg mt-4 font-semibold">
            Do you want to declare a Disaster?
          </p>
        )}
        {!canDeclareDisaster && (
          <p className="text-lg mt-2 font-semibold">
            Declaring & Approving Disaster can only be done by authorized
            users.
          </p>
        )}
        <div className="mt-4 flex justify-between gap-3">
          {!canDeclareDisaster ? (
            <button
              onClick={onClose} // Close button functionality
              className="btn-cancel flex-1 rounded p-4 text-white hover:bg-gray-500"
            >
              Close
            </button>
          ) : (
            <>
              <button
                onClick={() => onConfirm("no")}
                className="btn-cancel flex-1 rounded text-white hover:bg-gray-500"
              >
                No
              </button>
              <button
                onClick={() => onConfirm("yes")}
                className="btn-default flex-1 rounded p-4 text-white hover:bg-blue-700"
              >
                Yes
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
